export enum SharedDataTags {
  INFO_PROFILE = 'informacoes-perfil',
  USER_TOKEN = 'token',
  TOKEN_EXPIRATION = 'expiracao-token',
  USER_OPERATOR = 'usuario-operador',
  LIKERT_CONTEXTS = 'contextos-likert-disponiveis',
  MENU = 'menu'
}

export enum SharedDataErrors {
  NOT_FOUND = 'Tag solicitada não encontrada',
  OVERWRITE = 'Tag inserida já utilizada'
}
